function z(n) {
  return typeof n == "boolean";
}
function s(n) {
  return typeof n == "string";
}
function y(n) {
  return typeof n == "number";
}
function E(n) {
  return Number.isInteger(n);
}
function Z(n) {
  return y(n) && !E(n);
}
function m(n) {
  return Array.isArray(n);
}
function l(n) {
  return typeof n == "function";
}
function D(n) {
  return n instanceof RegExp;
}
function B(n) {
  return typeof n == "object" && !m(n) && !C(n);
}
function k(n) {
  return s(n) || y(n) || z(n);
}
function _(n) {
  return typeof n > "u";
}
function C(n) {
  return n === null;
}
function a(n) {
  return !(_(n) || C(n));
}
function nn(...n) {
  return P(n);
}
function P(n) {
  return n.every((t) => a(t));
}
function w(n) {
  return !a(n);
}
function tn(...n) {
  return n.find((t) => a(t)) ?? void 0;
}
const en = (n) => m(n) ? n.length === 0 : Object.keys(n).length === 0, R = (n, t) => n.replace(
  /<(\w+)>/g,
  (e, r) => {
    const o = t[r];
    if (w(o))
      throw new Error(`Invalid variable expansion <${r}> in message format: ${n}`);
    return o;
  }
);
function f(...n) {
  throw new Error(n.join(""));
}
function rn(n, t) {
  throw new Error(
    R(n, t)
  );
}
function on(n) {
  throw n;
}
const cn = (n, ...t) => l(n) ? n(...t) : n;
function sn(...n) {
}
const un = (n) => n, j = (n) => {
  const t = n.toString().split(".");
  return t.length < 2 ? 1 : Math.pow(10, t[1].length);
}, p = (...n) => n.reduce(
  (t, e) => {
    const r = j(t), o = j(e);
    return r > o ? r : o;
  },
  -1 / 0
), fn = (...n) => n.reduce(
  (t, e) => {
    const r = p(t, e);
    return t * r * (e * r) / (r * r);
  },
  1
), ln = (...n) => n.reduce(
  (t, e) => {
    const r = p(t, e);
    return t * r / (e * r);
  }
), an = (...n) => {
  const t = p(...n);
  return n.reduce(
    (e, r) => e + t * r,
    0
  ) / t;
}, dn = (...n) => {
  const t = p(...n), [e, ...r] = n;
  return r.reduce(
    (o, c) => o - t * c,
    e * t
  ) / t;
}, mn = (n, t, e) => Math.min(Math.max(n, t), e);
function U() {
  return Intl.DateTimeFormat().resolvedOptions().locale;
}
let d = {
  locale: U(),
  currency: "GBP",
  currencySign: "£",
  thousands: ","
};
function pn(n) {
  d = { ...d, ...n };
}
const hn = (n, t, e = 1) => {
  const o = t < n ? -Math.abs(e) : e;
  return Array(1 + Math.floor(Math.abs((t - n) / e))).fill(n).map((c, i) => c + i * o);
};
function G(n, t = {}) {
  return new Intl.NumberFormat(
    t.locale,
    t
  ).format(n);
}
function gn(n, t = {}) {
  return G(
    n,
    {
      style: "currency",
      currency: d.currency,
      ...t
    }
  );
}
function H(n, t = d.thousands) {
  if (w(n))
    return "";
  const e = n.toString().split("."), r = /(\d+)(\d{3})/;
  for (; r.test(e[0]); )
    e[0] = e[0].replace(r, `$1${t}$2`);
  return e.join(".");
}
function V(n, t = /,\s*|\s+/) {
  return w(n) ? [] : s(n) ? n.length ? n.split(t) : [] : m(n) ? n : [n];
}
function W(n, t = !0, e = {}) {
  return B(n) ? n : V(n).reduce(
    (o, c) => (o[c] = l(t) ? t(c) : t, o),
    e
  );
}
function bn(n) {
  return !s(n) || n.length === 0 ? [] : n.split(/\s*\n+\s*/).filter(
    function(e) {
      return e.length > 0;
    }
  );
}
function v(n, t = " ", e = t) {
  const r = [...n], o = r.pop() ?? "";
  return r.length ? [r.join(t), o].join(e) : o;
}
function yn(n, t = ", ", e = " and ") {
  return v(n, t, e);
}
function wn(n, t = ", ", e = " or ") {
  return v(n, t, e);
}
function h(n) {
  return n.charAt(0).toUpperCase() + n.slice(1).toLowerCase();
}
function q(n) {
  return n.replace(
    // /(?:^|\s)\S/g,
    /(\w+)/g,
    h
  );
}
function $n(n) {
  return n.split("/").map(
    // each segment can be like foo_bar which we convert to FooBar
    (t) => t.split("_").map(h).join("")
  ).join("/");
}
function jn(n) {
  return n.split("/").map(
    // each segment can be like foo_bar which we convert to fooBar
    (t) => t.split("_").map((e, r) => r ? h(e) : e).join("")
  ).join("/");
}
function $(n, t = {}) {
  const e = t[n];
  if (a(e))
    return e;
  let r;
  return n.match(/(ss?|sh|ch|x)$/) ? n + "es" : (r = n.match(/(.*?[^aeiou])y$/)) ? r[1] + "ies" : n.match(/([^s\d\W])$/) ? n + "s" : n;
}
function In(n, t = {}) {
  const e = t[n];
  return a(e) ? e : n.match(/(ss|sh|ch|x)es$/) ? n.replace(/es$/, "") : n.match(/([^aeiou])ies$/) ? n.replace(/ies$/, "y") : n.match(/([^s\d\W])s$/) ? n.replace(/s$/, "") : n;
}
function J(n, t, e, r = "no") {
  return (n ? H(n) : r) + " " + (n === 1 ? t : e || $(t));
}
function Sn(n, t, e, r = "No") {
  return J(n, t, e, r);
}
const Fn = h, On = q, xn = $, Ln = $;
function b(n) {
  if (l(n))
    return n;
  if (D(n))
    return (t) => n.test(t);
  if (B(n))
    return (t) => !!n[t];
  if (m(n) || s(n)) {
    const t = W(n);
    return (e) => !!t[e];
  } else
    f("Invalid selector() specification: " + n);
}
function Mn(n, t = {}) {
  const e = t.include && b(t.include), r = t.exclude && b(t.exclude);
  return Q(W(n)).reduce(
    (o, [c, i]) => e && !e(c, i, n, o) || r && r(c, i, n, o) ? o : (t.key && (c = t.key(c, i, n, o)), t.value && (i = t.value(i, c, n, o)), {
      ...o,
      [c]: i
    }),
    {}
  );
}
function Nn(n, t) {
  return Object.keys(n).reduce(
    (e, r) => ({
      ...e,
      [r]: t(n[r], r)
    }),
    {}
  );
}
const K = (n, t, e = {}) => {
  let r = {};
  const o = { delete: !1, ...e }, c = b(t);
  return Object.keys(n).map(
    (i) => {
      if (c(i)) {
        let u = n[i];
        o.delete && delete n[i], o.key && (i = o.key(i)), o.value && (u = o.value(u)), r = {
          ...r,
          [i]: u
        };
      }
    }
  ), r;
}, Tn = K, An = (n, t) => {
  const e = n[t];
  return delete n[t], e;
}, En = Object.keys, Bn = Object.values, Q = Object.entries, g = (n, t) => l(t) ? t(n) : n[t], I = (n, t) => !!g(n, t), S = (n, t) => {
  const e = g(n, t);
  return E(e) ? e : s(e) && parseInt(e) || 0;
}, F = (n, t) => {
  const e = g(n, t);
  return y(e) ? e : s(e) && parseFloat(e) || 0;
}, O = (n, t) => (g(n, t) || "").toString(), x = (n) => (t, e) => S(t, n) - S(e, n), L = (n) => (t, e) => F(t, n) - F(e, n), M = (n) => (t, e) => {
  const r = O(t, n).toLowerCase(), o = O(e, n).toLowerCase();
  return r > o ? 1 : o > r ? -1 : 0;
}, N = (n) => (t, e) => {
  const r = I(t, n), o = I(e, n);
  return r === o ? 0 : r ? 1 : -1;
}, X = {
  num: L,
  int: x,
  str: M,
  bool: N,
  number: L,
  integer: x,
  string: M,
  boolean: N
}, T = (n) => n, A = (n) => (t, e) => n(e, t), Y = {
  asc: T,
  desc: A,
  ascending: T,
  descending: A
}, Cn = (n) => {
  const e = V(n).map(
    (r) => {
      if (l(r))
        return r;
      if (s(r)) {
        const o = r.match(/^(\w+)(?::(\w+))?(?::(\w+))?$/) || f(`Invalid sort field: ${r}`), c = X[o[2] || "string"] || f(`Invalid sort type "${o[2]}" in sort field: ${r}`);
        return (Y[o[3] || "asc"] || f(`Invalid sort order "${o[3]}" in sort field: ${r}`))(c(o[1]));
      } else
        f(`Invalid sort field: ${r}`);
    }
  );
  return (r, o) => {
    for (let c = 0; c < e.length; c++) {
      const i = e[c], u = i(r, o);
      if (u !== 0)
        return u;
    }
    return 0;
  };
};
function Vn(n, t = 300) {
  let e;
  return (...r) => {
    clearTimeout(e), e = setTimeout(
      () => n(...r),
      t
    );
  };
}
function Wn(n) {
  return new Promise((t) => setTimeout(t, n));
}
export {
  Sn as Inflect,
  an as add,
  T as ascendingOrder,
  I as booleanField,
  N as booleanSort,
  h as capitalise,
  q as capitaliseWords,
  Fn as capitalize,
  On as capitalizeWords,
  mn as clamp,
  H as commas,
  gn as currency,
  Vn as debounce,
  U as defaultLocale,
  A as descendingOrder,
  ln as divide,
  sn as doNothing,
  Q as entries,
  K as extract,
  f as fail,
  rn as failMsg,
  tn as firstValue,
  R as format,
  G as formatNumber,
  g as getField,
  a as hasValue,
  P as hasValues,
  Mn as hash,
  nn as haveValue,
  un as identity,
  J as inflect,
  S as integerField,
  x as integerSort,
  m as isArray,
  z as isBoolean,
  en as isEmpty,
  Z as isFloat,
  l as isFunction,
  E as isInteger,
  C as isNull,
  y as isNumber,
  B as isObject,
  D as isRegExp,
  k as isSimple,
  s as isString,
  _ as isUndefined,
  v as joinList,
  yn as joinListAnd,
  wn as joinListOr,
  En as keys,
  cn as maybeFunction,
  Cn as multiSort,
  fn as multiply,
  w as noValue,
  F as numberField,
  L as numberSort,
  Nn as objMap,
  Tn as objSubset,
  $ as plural,
  xn as pluralise,
  Ln as pluralize,
  hn as range,
  An as remove,
  on as rethrow,
  b as selector,
  pn as setNumberDefaults,
  In as singular,
  Wn as sleep,
  jn as snakeToCamel,
  $n as snakeToStudly,
  Y as sortOrders,
  X as sortTypes,
  W as splitHash,
  bn as splitLines,
  V as splitList,
  O as stringField,
  M as stringSort,
  dn as subtract,
  Bn as values
};
//# sourceMappingURL=badger-utils.js.map
